var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{staticClass:"documentation"},[(_vm.isLoaded)?_c('v-container',[_c(_vm.markdown,_vm._g({tag:"div"},_vm.$listeners))],1):_c('v-container',[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }